import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-grid-switch-cell',
  standalone: true,
  imports: [CommonModule],
  template: `
    <label class="switch" [class.disabled]="disabled" (click)="$event.stopPropagation()">
      <input
        type="checkbox"
        role="switch"
        [checked]="checked"
        [disabled]="disabled"
        (change)="onToggle($event)"
        (click)="$event.stopPropagation()"
      />
      <span class="slider"></span>
    </label>
  `,
  styleUrls: ['./grid-switch-cell.component.scss']
})
export class GridSwitchCellComponent {
  @Input() checked = false;
  @Input() disabled = false;

  @Output() checkedChange = new EventEmitter<boolean>();

  onToggle(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.checkedChange.emit(input.checked);
  }
}